import axios from 'axios';

export default {
  async getInfo(secretKey) {
    const response = await axios.get(`/api/QrRegistration/${secretKey}/info`);
    return response.data;
  },
  async register(secretKey) {
    const response = await axios.post(`/api/QrRegistration/${secretKey}/register`);
    return response.data;
  }
};
